import React, { useMemo, useState } from 'react';

/**
 * Универсальный компонент логотипа с каскадом URL и ограничением высоты.
 * ✅ УНИФИЦИРОВАННЫЕ РАЗМЕРЫ: Все логотипы адаптируются под заданную высоту
 * без переполнения и обрезаний, сохраняя пропорции
 * 
 * props:
 * - sources: string[] — кандидаты URL
 * - alt: string
 * - height: number (px), по умолчанию 32
 * - maxWidth: number (px), по умолчанию height * 4 (для широких логотипов)
 * - style: inline styles
 * - mode: 'image' | 'cutout' — обычный <img> или "вырез" (mask) на акцентной подложке
 */
const LogoImage = ({ sources, alt, height = 32, maxWidth, style, mode = 'image' }) => {
  const list = useMemo(() => (Array.isArray(sources) ? sources.filter(Boolean) : []), [sources]);
  const [index, setIndex] = useState(0);

  if (!list.length) return null;

  const onError = () => {
    if (index < list.length - 1) setIndex(index + 1);
  };

  const finalHeight = Number(height) || 32;
  const finalMaxWidth = maxWidth || (finalHeight * 4); // По умолчанию 4:1 для широких логотипов

  if (mode === 'cutout') {
    const src = list[index];

    // Важно: задаём URL маски через CSS variable, чтобы работало в ::before
    return (
      <span
        className="mb-logo-cutout"
        style={{
          '--mb-logo-mask-w': `${finalMaxWidth}px`,
          '--mb-logo-mask-h': `${finalHeight}px`,
          '--mb-logo-mask-url': `url("${src}")`,
          ...style,
        }}
      >
        {/* <img> нужен для отображения логотипа и каскада onError. Маска (если поддержана) рисуется через ::before,
            но сам <img> мы не скрываем, чтобы не получать "пустую плашку" при проблемах загрузки mask по URL (CORS/SVG). */}
        <img
          src={src}
          alt={alt || 'logo'}
          className="mb-logo-cutout__img"
          onError={onError}
          loading="eager"
          decoding="sync"
        />
      </span>
    );
  }

  return (
    <img
      src={list[index]}
      alt={alt || 'logo'}
      onError={onError}
      loading="eager"
      decoding="sync"
      style={{
        display: 'inline-block',
        height: finalHeight,
        maxHeight: finalHeight,
        maxWidth: finalMaxWidth,
        width: 'auto',
        objectFit: 'contain',
        verticalAlign: 'middle',
        imageRendering: 'auto',
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
        marginRight: 8,
        ...style,
      }}
    />
  );
};

export default LogoImage;

